import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { IProductionReceiptRepository } from "./IProductionReceiptRepository";
import { ProductionReceipt } from "src/app/models/Production/production-receipt";

@Injectable(
    {
        providedIn: "root"
    }
)
export class ProductionReceiptRepository extends GenericRepository<ProductionReceipt> implements IProductionReceiptRepository {

    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/ProductionReceipt', environment.urlAddress);
    }

    GetAll(currentPage: number, recordsPerPage: number, filterText: string): Observable<any> {
        filterText = filterText.split('/').join('~');
        if (filterText == "") {
            filterText = "|";
        }

        return this.Get('SelectAll' + '/' + currentPage + '/' + recordsPerPage + '/' + filterText).pipe(map(this.extractData), catchError(this.handleError));
    }

    SelectPostingSetup(postingSetup: any, godownCode: string): Observable<ResponseModel> {
        return this.PostData('/SelectPostingSetup' + '/' + godownCode, postingSetup).pipe(map(this.extractData), catchError(this.handleError));
    }

    SaveRec(item: ProductionReceipt): Observable<ResponseModel> {
        return this.PostData('/SaveRec', item).pipe(map(this.extractData), catchError(this.handleError));
    }

    DeleteRec(invoiceNumber: string): Observable<ResponseModel> {
        return this.Delete('DeleteRec/' + invoiceNumber).pipe(map(this.extractData), catchError(this.handleError));
    }

    NavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
        return this.Get('NavRec/' + navType + '/' + currentIndex).pipe(map(this.extractData), catchError(this.handleError));
    }

    GetRec(invoiceNumber: string): Observable<ResponseModel> {
        return this.Get('GetRec/' + invoiceNumber).pipe(map(this.extractData), catchError(this.handleError));
    }

    ProcessProductionReceiptSearch(productionReceiptObj: any): Observable<any> {
        return this._http.post(this.url + 'api/ProductionReceipt/ProductionReceiptSearch', productionReceiptObj, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }
}